import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormFieldControlService } from '../../../services/form-field-control.service';
import { FormField } from '../../../shared/form-field/form-field';

@Component({
  standalone: false,
  selector: 'import-form',
  templateUrl: 'import-form.template.html',
  providers: [FormFieldControlService],
})
export class ImportFormComponent implements OnInit {
  @Input() formFields: FormField<string>[] = [];
  form: FormGroup;
  payLoad = '';

  constructor(private qcs: FormFieldControlService) {}

  ngOnInit() {
    this.form = this.qcs.toFormGroup(this.formFields);
  }

  onSubmit() {
    // TODO: on submit
  }
}
